import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { workplaceService } from '@api/services/services';
import { EntityState } from '@api/models/enums/EntityState';
import { WorkplaceDto } from '@api/models/workplace/WorkplaceDto';

export interface WorkplaceListFilter extends ListFilter {
  state?: EntityState;
  establishment?: ReferenceDto;
}

export type WorkplaceListState = ListType<WorkplaceDto, WorkplaceListFilter>;

const initialState: WorkplaceListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    state: EntityState.Active,
    sortBy: 'name',
    sortDesc: false,
  },
};

export const workplaceListSlice = listSlice({
  name: 'workplaceList',
  initialState,
});

export const selectWorkplaceList = (state: RootState) => state.workplaceList;
export const workplaceListActions = workplaceListSlice.actions;

export const getWorkplaceList = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
    const storeState = store.getState();
    const data = selectWorkplaceList(storeState);

    const handleGetData = (size: number) => {
      return workplaceService.query({
        q: data.query.q,
        state: data.query.state,
        establishments: data.query.establishment ? [data.query.establishment.id] : undefined,
        page: data.query.page,
        size: size,
        sort: getListSort(data)},
        { cancelToken: cancelToken as any }
      );
    };

    getList({
      dispatch,
      cancelToken,
      state: data.state,
      actions: workplaceListActions,
      getData: handleGetData,
    });
  };
